import React from 'react'
import { Circles } from 'react-loader-spinner'
const Spinner = () => {
  return (
    <div className='flex justify-center items-center h-screen'>
            <Circles
        height="100"
        width="100"
        color="#4fa94d"
        ariaLabel="circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
        </div>
  )
}

export default Spinner